import { useTranslation } from "react-i18next";
import { useStartupParamsStore } from "@/store/startupParams";

export const useGoalParkTitle = () => {
  const { t } = useTranslation();
  const serviceType = useStartupParamsStore((state) => state.serviceType);
  const parkName = t(
    serviceType === "taxi"
      ? "goals.common.parkNameTaxi"
      : "goals.common.parkNameCourier"
  );

  return t("goals.common.parkGoal", { parkName });
};
